import styled from 'styled-components'

const SignOutAction = styled.button`
    position: absolute;
    top: 20px;
    right: 15px;
    color: #6c6b6b;
    font-size: 26px;
    padding: 0px 6px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px #918e8e;
    border: none;
    background: transparent;
    display: inline-block;
    z-index: 20;
    &:hover {
        opacity: 0.7;
    }
`

const Text = styled.span`
    position: absolute;
    right: 45px;
    font-size: 14px;
    font-weight: 500;
    top: 8px;
    white-space: nowrap;
    max-width: 50vw;
    overflow: hidden;
    text-overflow: ellipsis;
`

export {
    SignOutAction,
    Text
}